import {call, put, takeLatest} from 'redux-saga/effects';
import PerformanceApi from '../../api/PerformanceApi';
import performanceActions from '../../actions/fortnite-game/performance.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getPerformance(action) {
    try {
        delete action.payload.silent;

        const {data, versions, wau} = yield call(PerformanceApi.getData, action.payload);
        yield put(
            performanceActions.getPerformanceSuccess({
                data,
                versions,
                wau,
                error: data && data.length ? undefined : NO_DATA_ERROR_CODE
            })
        );
    } catch (e) {
        yield put(performanceActions.getPerformanceFailed(getErrorCodeFromResponse(e), e));
    }
}

function* performanceSaga() {
    yield takeLatest(performanceActions.TYPES.GET_PERFORMANCE, getPerformance);
}

export default performanceSaga;
